export default {
  unionDashboard: {
    // titles per role-scoped variant
    titleParent: "National Dashboard",
    titleUnion: "Union Dashboard",
    titleSociety: "Society Dashboard",
    titleFactory: "Factory Dashboard",
    eudrTitle: "EUDR Due Diligence",
    // filters
    factory: "Factory",
    society: "Society",
    union: "Union",
    dateRange: "Date Range",
    // identifiers
    unionNumbers: "Union Numbers",
    societyNumbers: "Society Numbers",
    factoryNumbers: "Factory Numbers",
    // core KPIs
    totalFarmers: "Total Farmers",
    totalFarms: "Total Farms",
    totalReceiving: "Total Receiving",
    totalProcessing: "Total Processing",
    // tiered KPIs (parent, test org): society = factory tier, union = union tier
    receivingBySociety: "Receiving by Society",
    processingBySociety: "Processing by Society",
    receivingByUnion: "Receiving by Union",
    processingByUnion: "Processing by Union",
    // operational
    unions: "Unions",
    societies: "Societies",
    mills: "Dry Milling Factories",
    crops: "Crops",
    bushes: "Bushes / Trees",
    // charts
    receivingVsProcessing: "Receiving vs Processing",
    receivingVsProcessingTT: "Cherry received compared to processed output.",
    breakdownByUnion: "Receiving vs Processing by Union",
    breakdownBySociety: "Receiving vs Processing by Society",
    breakdownByFactory: "Receiving vs Processing by Factory",
    breakdownByCrop: "Receiving vs Processing by Crop",
    receiving: "Receiving",
    processing: "Processing",
    kilograms: "Kilograms (kg)",
    avgQualityScore: "Average Quality Score",
    avgQualityScoreTT: "Aggregated average cupping/quality score for this scope.",
    avgScore: "Avg Score",
    greenCoffeeGrades: "Green Coffee Quality Levels",
    greenCoffeeGradesTT: "Distribution of green coffee across quality grades.",
    bags: "Bags",
  },
};
